/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Incorrect_Url_Missing_EmailInputs */

const en_toast_incorrect_url_missing_email = /** @type {(inputs: Toast_Incorrect_Url_Missing_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorrect URL! Missing email.`)
};

const nl_toast_incorrect_url_missing_email = /** @type {(inputs: Toast_Incorrect_Url_Missing_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onjuiste URL! E-mail ontbreekt.`)
};

/**
* | output |
* | --- |
* | "Incorrect URL! Missing email." |
*
* @param {Toast_Incorrect_Url_Missing_EmailInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_incorrect_url_missing_email = /** @type {((inputs?: Toast_Incorrect_Url_Missing_EmailInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Incorrect_Url_Missing_EmailInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_incorrect_url_missing_email(inputs)
	return en_toast_incorrect_url_missing_email(inputs)
});